import TseObject from "@/assets/models/TseObject";

export default class Tse {
    string: string = '';
    object: TseObject = new TseObject();
}
